<div *ngFor="let dosya of dosyalar">
  <button mat-stroked-button  (click)="downloadFile(dosya)" class="mr-4 mt-2"><mat-icon>file_download</mat-icon>{{dosya.dosyaAdi}}</button>
</div>
